import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { CartService } from '../../../services/cart.service';
import { AuthService } from '../../../services/auth.service';
import { LanguageService } from '../../../services/language.service';
import { LanguageSelectorComponent } from '../language-selector/language-selector';
import { MobileLanguageSelectorComponent } from '../mobile-language-selector/mobile-language-selector';
import { User } from '../../../interfaces/product.interface';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  imports: [CommonModule, RouterModule, LanguageSelectorComponent, MobileLanguageSelectorComponent],
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class Header implements OnInit, OnDestroy {
  cartCount: number = 0;
  isScrolled = false;
  isProductDetailPage = false;
  currentUser: User | null = null;
  isMenuOpen = false;

  constructor(
    private cartService: CartService, 
    private authService: AuthService,
    private languageService: LanguageService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Listen to cart changes
    this.cartService.getCartCount().subscribe(count => {
      this.cartCount = count;
    });

    // Listen to authentication state changes
    this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
    });

    // Listen for route changes
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.isProductDetailPage = event.url.includes('/product/');
      });

    // Check initial route
    this.isProductDetailPage = this.router.url.includes('/product/');
  }

  ngOnDestroy(): void {
    // Cleanup if needed
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isScrolled = scrollTop > 50;
    // console.log('Scroll Debug:', {
    //   scrollTop,
    //   isScrolled: this.isScrolled,
    //   isProductDetailPage: this.isProductDetailPage,
    //   shouldHaveInitialClass: !this.isScrolled && !this.isProductDetailPage,
    //   shouldHaveFloatingClass: this.isScrolled && !this.isProductDetailPage
    // });
  }

  toggleCart() {
    this.router.navigate(['/cart']);
    this.isMenuOpen = false;
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  isLoggedIn(): boolean {
    // Use the current user observable state instead of sync check
    return this.currentUser !== null;
  }

  logout(): void {
    this.authService.logout().subscribe(() => {
      this.router.navigate(['/login']);
      this.isMenuOpen = false;
    });
  }

  goToOrderHistory(): void {
    this.router.navigate(['/orders']);
    this.isMenuOpen = false;
  }

  navigateTo(path: string): void {
    this.router.navigate([path]);
    this.isMenuOpen = false;
  }

  getUserInitials(): string {
    if (this.currentUser) {
      return this.currentUser.name.charAt(0).toUpperCase();
    }
    return '';
  }

  // Translation method
  t(key: string, params?: { [key: string]: string | number }): string {
    return this.languageService.t(key, params);
  }

  isNavActive = false;

  toggleNav() {
    this.isNavActive = !this.isNavActive; // toggle class
  }

  closeMenu() {
    this.isNavActive = false;
    // Allow close animation to complete before hiding element
    setTimeout(() => {
      // Animation completes after 300ms (matching CSS animation duration)
    }, 300);
  }
}
